export default "__VITE_ASSET__66IeiyXC__"